/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Input from '../../../adminv2/common/Input'
import CheckboxRadio from '../../../adminv2/common/CheckboxRadio'
import Select from 'react-select'
import Notifications from '@services/Notifications'
import Consultations from '@services/Consultations'
import Alert from '../../../adminv2/common/Alert'
import CompanyModal from './Company.Modal'
import { history } from '@services/History'
import { showAlert } from '../alert/Alert.dux'
import { useDispatch } from 'react-redux'
import _ from 'lodash'

export default function CompanyIntegrationForm(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  let company = props.company
  // var selectedIntegrationOptions = company.integration_type ? company.integration_type?.split(',') : []

  let { formData, setFormData, initialFormData, setInitialFormData } = props

  const [integrationOptions, setIntegrationOptions] = useState([
    { label: 'App', checked: company.integration_type === 'app', name: 'app', value: 'app' },
    {
      label: 'Widget',
      checked: company.integration_type === 'widget' || company.integration_type === 'Widget',
      name: 'widget',
      value: 'widget',
    },
    { label: 'Sdk', checked: company.integration_type === 'sdk', name: 'sdk', value: 'sdk' },
    {
      label: t('integrationWhiteLabel'),
      checked: company.integration_type === 'white_label',
      name: 'white_label',
      value: 'white_label',
    },
  ])
  const [anonimousUsersOptions, setAnonimousUsersOptions] = useState([
    { label: t('si'), checked: company.anonymous_allowed ? true : false, name: 'aa', value: true },
    { label: t('no'), checked: company.anonymous_allowed ? false : true, name: 'bb', value: false },
  ])
  const [anonimousUsersTypeOptions, setAnonimousUsersTypeOptions] = useState([
    {
      label: 'Free',
      checked: company.anonymous_status === 0 || company.anonymous_status > 2 ? true : false,
      name: 'free',
      value: '0',
    },
    { label: 'Premium', checked: company.anonymous_status === 1 ? true : false, name: 'premium', value: '1' },
    { label: 'Freemium', checked: company.anonymous_status === 2 ? true : false, name: 'freemium', value: '2' },
  ])
  const [tokenTypeOptions] = useState([
    { value: 'custom_token', label: 'Custom Token' },
    { value: 'email', label: 'Email' },
    { value: 'mobile_phone', label: t('integrationPhone') },
    { value: 'nid_number', label: 'NID' },
  ])
  const [loginTypeOptions] = useState([
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'nid_number', label: 'NID' },
  ])

  const [selectedLoginType, setSelectedLoginType] = useState(
    loginTypeOptions.find((item) => item.value === company.login_type)
  )
  const [selectedTokenType, setSelectedTokenType] = useState(
    tokenTypeOptions.find((item) => item.value === company.token_type)
  )

  const [showModal, setShowModal] = useState(false)

  const [events, setEvents] = useState()
  const [selectedEvents, setSelectedEvents] = useState()

  const formatArrayToSolect = (array) => {
    let formattedData = []
    if (array && array.length > 0) {
      array.map((element) => formattedData.push({ value: element.id, label: element.name }))
    }
    return formattedData
  }

  useEffect(() => {
    getAndSetEventsOptions()
    initializeFormData()
  }, [])

  const initializeFormData = () => {
    let initial = {
      integration_type: company.integration_type || '',
      api_key: company.api_key || '',
      secret_key: company.secret_key || '',
      fcm_sender_id: company.fcm_sender_id || '',
      fcm_server_key: company.fcm_server_key || '',
      anonymous_allowed: company.anonymous_allowed === 0 ? false : true,
      anonymous_status: company.anonymous_status ? company.anonymous_status.toString() : '',
      token_type: company.token_type || '',
      login_type: company.login_type || '',
      app_name: company.app_name || '',
      app_store_url_ios: company.app_store_url_ios || '',
      app_store_url_android: company.app_store_url_android || '',
      url_widget: company.url_widget || '',
      push_webhook: company.push_webhook || '',
      events_ids: company.events_ids ? company.events_ids : [],
    }
    setInitialFormData(initial)
    setFormData(initial)
  }

  const getAndSetEventsOptions = async () => {
    Notifications.updateHeaders({
      'X-Md-Authorization': import.meta.env.VITE_REACT_APP_X_MD_AUTH,
    })
    const eventsFormatted = await Notifications.events.index().then((response) => {
      let selectFormatted = []
      if (response && response.data) {
        selectFormatted = formatArrayToSolect(response.data)
        setEvents(selectFormatted)
      }
      return selectFormatted
    })

    Notifications.events.show(company.api_key).then((response) => {
      if (response && response.data) {
        let newArray = []
        let companyRawEventIds = response.data.map((element) => element.id)
        newArray = eventsFormatted.filter((item) => companyRawEventIds.includes(item.value))
        setSelectedEvents(newArray)
      }
    })
  }

  const formatFormParams = (params) => {
    let formattedParams

    formattedParams = {
      integration_type: params.integration,
      api_key: company.api_key,
      secret_key: company.secret_key,
      fcm_sender_id: params.senderId,
      fcm_server_key: params.serverKey,
      anonymous_allowed: params.anonimousUsers === 'true' ? 1 : 0,
      anonymous_status: parseInt(params.anonimousUsersType),
      token_type: selectedTokenType ? selectedTokenType.value : null,
      login_type: selectedLoginType ? selectedLoginType.value : null,
      app_name: params.appName,
      app_store_url_ios: params.appUrlIos,
      app_store_url_android: params.appUrlAndroid,
      url_widget: params.widgetUrl,
      push_webhook: params.push_webhook,
      events_ids: selectedEvents ? selectedEvents.map((element) => element?.value) : [],
    }

    return formattedParams
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const form = document.getElementById('integration-form')
      const formDataLocal = new FormData(form)
      const formProps = Object.fromEntries(formDataLocal)
      await Consultations.company
        .update(company.id, formatFormParams(formProps))
        .then(() => {
          dispatch(
            showAlert({
              text: t('integrationCompanyUpdateSuccess'),
              important: t('goodJob'),
              type: 'success',
            })
          )
        })
        .then(setInitialFormData(formData))
        .catch((e) => {
          dispatch(
            showAlert({
              text: t('integrationCompanyUpdateError'),
              important: 'Oh snap!',
              type: 'danger',
            })
          )
        })
    } catch (e) {
      console.error(e)
    }
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }

  return (
    <div className="companies-form md-form integration-form-container">
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('integration-submit-btn').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/companies')}
        />
      ) : null}
      <Alert timeOut={3000} />
      <h1>{t('integration')}</h1>
      <form className="integration-form" onSubmit={handleSubmit} id="integration-form">
        <CheckboxRadio
          className="form-control"
          id="integration"
          name="integration"
          label={t('integrationIntegrationType')}
          required
          options={integrationOptions}
          handleOptions={(options) => {
            setIntegrationOptions(options)
            setFormData({ ...formData, integration_type: options.find((e) => e.checked).value })
          }}
          type="radio"
        />
        <Input
          className="form-control"
          id="apiKey"
          name="apiKey"
          label={t('integrationApiKeyLabel')}
          value={company?.api_key}
          required
          onChange={(api_key) => setFormData({ ...formData, api_key: api_key })}
          displayRequiredMark={false}
          disabled
        />
        <Input
          className="form-control"
          id="secretkey"
          name="secretkey"
          label={t('integrationSecretkeyLabel')}
          value={company?.secret_key}
          required
          displayRequiredMark={false}
          onChange={(secret_key) => setFormData({ ...formData, secret_key: secret_key })}
          disabled
        />
        <Input
          className="form-control"
          id="senderId"
          name="senderId"
          label="Sender ID"
          defaultValue={company?.fcm_sender_id}
          onChange={(fcm_sender_id) => setFormData({ ...formData, fcm_sender_id: fcm_sender_id })}
          required
        />
        <Input
          className="form-control"
          id="serverKey"
          name="serverKey"
          label="Server Key"
          defaultValue={company?.fcm_server_key}
          onChange={(value) => setFormData({ ...formData, fcm_server_key: value })}
          required
        />
        <CheckboxRadio
          className="form-control"
          id="anonimousUsers"
          name="anonimousUsers"
          label={t('integrationAnonimousUsers')}
          required
          options={anonimousUsersOptions}
          handleOptions={(options) => {
            setAnonimousUsersOptions(options)
            setFormData({ ...formData, anonymous_allowed: options.find((e) => e.checked).value })
          }}
          type="radio"
        />
        <CheckboxRadio
          className="form-control"
          id="anonimousUsersType"
          name="anonimousUsersType"
          label={t('integrationAnonimousUsersType')}
          required
          options={anonimousUsersTypeOptions}
          handleOptions={(options) => {
            setAnonimousUsersTypeOptions(options)
            setFormData({ ...formData, anonymous_status: options.find((e) => e.checked).value })
          }}
          type="radio"
        />
        <div>
          <label>{t('integrationTokenTypeLabel')}</label>
          <Select
            options={tokenTypeOptions}
            value={selectedTokenType}
            onChange={(option) => {
              setSelectedTokenType(option)
              setFormData({ ...formData, token_type: option.value })
            }}
          />
        </div>
        <div>
          <label>{t('integrationLoginTypeLabel')}</label>
          <Select
            options={loginTypeOptions}
            value={selectedLoginType}
            onChange={(option) => {
              setSelectedLoginType(option)
              setFormData({ ...formData, login_type: option.value })
            }}
          />
        </div>
        <Input
          className="form-control"
          id="appName"
          name="appName"
          label={t('integrationAppName')}
          onChange={(value) => setFormData({ ...formData, app_name: value })}
          defaultValue={company.app_name}
        />
        <Input
          className="form-control"
          id="appUrlAndroid"
          name="appUrlAndroid"
          label="App URL (Android)"
          onChange={(value) => setFormData({ ...formData, app_store_url_android: value })}
          defaultValue={company.app_store_url_android}
        />
        <Input
          className="form-control"
          id="appUrlIos"
          name="appUrlIos"
          label="App URL (IOS)"
          onChange={(value) => setFormData({ ...formData, app_store_url_ios: value })}
          defaultValue={company.app_store_url_ios}
        />

        <Input
          defaultValue={company.url_widget}
          className="form-control"
          id="widgetUrl"
          name="widgetUrl"
          label="App URL (Widget)"
          onChange={(value) => setFormData({ ...formData, url_widget: value })}
        />

        <hr></hr>
        <h1>Webhook</h1>
        <>
          <Input
            className="form-control"
            id="push_webhook"
            name="push_webhook"
            label="URL"
            defaultValue={company.push_webhook}
            onChange={(value) => setFormData({ ...formData, push_webhook: value })}
          />
          <div>
            <label>{t('integrationEvents')}</label>
            {events && selectedEvents ? (
              <Select
                isMulti
                name="events"
                options={events}
                defaultValue={selectedEvents}
                onChange={(options) => {
                  setSelectedEvents(options)
                  setFormData({ ...formData, events_ids: options.map((e) => e.value) })
                }}
              />
            ) : null}
          </div>
        </>

        <div className="companies-form--buttonsContainer">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkUnsavedChanges()}
            id="integration-submit-btn"
          >
            {t('Guardar')}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              if (checkUnsavedChanges()) {
                history.push('/companies')
              } else {
                setShowModal(true)
              }
            }}
          >
            {t('Cancelar')}
          </button>
        </div>
      </form>
    </div>
  )
}
